import { render, staticRenderFns } from "./articleinfo.vue?vue&type=template&id=6fcf4382"
import script from "./articleinfo.vue?vue&type=script&lang=js"
export * from "./articleinfo.vue?vue&type=script&lang=js"
import style0 from "./articleinfo.vue?vue&type=style&index=0&id=6fcf4382&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports